// API Configuration - use Vercel proxy in production (same-origin, no CORS), direct URL for local dev
import axios from 'axios';
import apiCache from '../utils/apiCache';

const PRODUCTION_API = 'https://clubfinder-api.onrender.com/api';
const PRODUCTION_SERVER = 'https://clubfinder-api.onrender.com';

/** Base URL for media (images/videos) - Render backend serves /media/ */
export const getMediaBaseUrl = () => {
  if (typeof window !== 'undefined') {
    const h = window.location.hostname;
    if (h === 'localhost' || h === '127.0.0.1') return 'http://localhost:5001';
    return PRODUCTION_SERVER;
  }
  return PRODUCTION_SERVER;
};

const getApiBaseUrl = () => {
  if (typeof window !== 'undefined') {
    const h = window.location.hostname;
    if (h === 'localhost' || h === '127.0.0.1') return 'http://localhost:5001/api';
    // Production: use relative /api so Vercel rewrites proxy to Render (avoids CORS, cold-start issues)
    return '/api';
  }
  return PRODUCTION_API;
};

const api = axios.create({
  baseURL: '/api',
  headers: { 'Content-Type': 'application/json' },
  timeout: 15000,
});

api.interceptors.request.use((config) => {
  config.baseURL = getApiBaseUrl();
  const sessionId = localStorage.getItem('sessionId');
  if (sessionId) config.headers['x-session-id'] = sessionId;
  return config;
});

// Sanitize error messages: never show localhost/127.0.0.1 in production
const isProd = typeof window !== 'undefined' && !/^localhost$|^127\./.test(window.location?.hostname || '');
const PROD_MSG = 'Unable to connect. The server may be starting—wait 60 seconds and try again.';
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (isProd) {
      const msg = err?.message || '';
      const respErr = err?.response?.data?.error || '';
      if (msg.toLowerCase().includes('localhost') || msg.includes('127.0.0.1') || msg.includes('5001')) {
        err.message = PROD_MSG;
      }
      if (respErr && (respErr.toLowerCase().includes('localhost') || respErr.includes('127.0.0.1') || respErr.includes('5001'))) {
        err.response.data.error = PROD_MSG;
      }
    }
    return Promise.reject(err);
  }
);

/** Cached GET: returns cached response if fresh, otherwise fetches and caches. Use for list/ref data. */
export async function getCached(url, opts = {}) {
  const { params = {}, ttlMs = 5 * 60 * 1000 } = opts;
  const key = apiCache.getKey(url, params);
  const hit = apiCache.get(key);
  if (hit !== null) return { data: hit };
  const res = await api.get(url, { params });
  apiCache.set(key, res.data, ttlMs);
  return res;
}

export default api;
export const API_BASE_URL = typeof window !== 'undefined' ? getApiBaseUrl() : PRODUCTION_API;

